import React from "react";
import useStorage from "../../../hooks/useStorage";
import { isLoading } from "../../../Loading";
import { API_CONFIG_KEY, productionApiConfig } from "../../../LocalStore";

export function useMfDevTools() {
  const [apiConfig, setApiConfig] = useStorage(API_CONFIG_KEY, productionApiConfig);
  const [isOpen, setOpen] = React.useState(false);

  const open = () => {
    setOpen(true);
  };

  const close = () => {
    setOpen(false);
  };

  return {
    isButtonVisible:
      !isLoading(apiConfig) && apiConfig.apiBaseUrl !== productionApiConfig.apiBaseUrl,
    open: open,
    close: close,
    apiConfig: isLoading(apiConfig) ? productionApiConfig : apiConfig,
    props: {
      isOpen: isOpen,
      onRequestClose: close,
      onChangeApiConfig: setApiConfig,
    },
  };
}
